import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=1d36effc&scoped=true&"
import script from "./GallerySection.vue?vue&type=script&lang=js&"
export * from "./GallerySection.vue?vue&type=script&lang=js&"
import style0 from "./GallerySection.vue?vue&type=style&index=0&id=1d36effc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d36effc",
  null
  
)

export default component.exports